'use client';
import React from 'react';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import List, { ListItem } from '@/components/@base/list';
import { Text } from '@/components/@base/typography';

import useCommonModalStore from '@/store/common-modal-store';

import { pageLevelLocalization } from '@/constant/localization';

const { product: productLocalization } = pageLevelLocalization;

export default function InstallationRulesButton() {
  const { setShow } = useCommonModalStore();

  const handleCloseModal = () => {
    setShow(false);
  };

  const handleOpenModal = () => {
    setShow(true, {
      DialogPanelProps: { className: 'rounded-xl p-0! overflow-visible max-w-[600px]' },
      Head() {
        return (
          <Container className='border-b-[1px] border-b-[#EBEFF4] p-8'>
            <Text bold className='text-right text-lg text-[#454545]'>
              {productLocalization.installationRulesTitle}
            </Text>
          </Container>
        );
      },
      Body() {
        return (
          <Container className='px-8 py-4 text-[#76767C]'>
            <List className='list-inside list-disc'>
              {productLocalization.installationRules.map((item, index) => (
                <ListItem className='py-2' key={index}>
                  {item}
                </ListItem>
              ))}
            </List>
          </Container>
        );
      },
      Action() {
        return (
          <Container center className='p-8 pt-2'>
            <Button
              className='h-[52px] w-full max-w-[184px]'
              size={SIZE_ENUM.SM}
              onClick={handleCloseModal}
            >
              {productLocalization.understood}
            </Button>
          </Container>
        );
      },
    });
  };

  return (
    <Button
      onClick={handleOpenModal}
      className='mx-1.5 h-auto border-[1px] border-[#FF9606] bg-[#FFFFFF] px-2 py-1 text-[13px] leading-4 font-bold text-[#FF9606]'
    >
      {productLocalization.installationConditions}
    </Button>
  );
}
